import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "text-muted fs-8 mb-1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "fst-italic" }, "(theo Cài đặt thủ tục nhập học)", -1)
const _hoisted_3 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm me-2" }, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "text-muted fs-8"
}
const _hoisted_6 = {
  key: 2,
  class: "table-responsive border rounded",
  style: {"max-height":"320px","overflow-y":"auto"}
}
const _hoisted_7 = { class: "table table-sm table-row-bordered fs-7 mb-0 align-middle" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-light sticky-top" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "ps-3 text-nowrap" }, "Chứng chỉ"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-nowrap" }, "Ngưỡng điểm"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"260px"} }, "Môn được miễn"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-nowrap" }, "Học phần bắt đầu học")
  ])
], -1)
const _hoisted_9 = { class: "ps-3 text-nowrap fw-semibold text-gray-800" }
const _hoisted_10 = {
  key: 0,
  class: "text-muted fs-8 fw-normal"
}
const _hoisted_11 = { class: "text-nowrap" }
const _hoisted_12 = {
  key: 0,
  class: "text-muted fs-9 fst-italic"
}
const _hoisted_13 = {
  key: 0,
  class: "text-muted fs-8 me-1"
}
const _hoisted_14 = { class: "text-gray-800" }
const _hoisted_15 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_16 = {
  key: 0,
  class: "badge badge-light-success fs-8 me-1"
}
const _hoisted_17 = { class: "text-gray-700" }
const _hoisted_18 = { class: "text-gray-800 text-nowrap" }
const _hoisted_19 = {
  key: 0,
  class: "badge badge-light-success fs-8 fw-normal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(" Bảng điều kiện miễn giảm Tiếng Anh tham khảo "),
      (_ctx.certificateName && _ctx.filteredMatched)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(" — " + _toDisplayString(_ctx.certificateName), 1)
          ], 64))
        : _createCommentVNode("", true),
      _hoisted_2
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createTextVNode("Đang tải bảng điều kiện...")
        ]))
      : (!_ctx.rows.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Chưa có điều kiện miễn giảm nào trong Cài đặt thủ tục nhập học."))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (r) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: r.id
                  }, [
                    _createElementVNode("td", _hoisted_9, [
                      _createTextVNode(_toDisplayString(r.certificateName) + " ", 1),
                      (r.variantLabel)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(r.variantLabel), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_11, [
                      (_ctx.criteria(r).length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, "thỏa tất cả"))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.criteria(r), (c, i) => {
                        return (_openBlock(), _createElementBlock("div", { key: i }, [
                          (c.type)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.skillLabel(c.type)), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("b", _hoisted_14, _toDisplayString(_ctx.bandText(r, c)), 1)
                        ]))
                      }), 128)),
                      (!_ctx.criteria(r).length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, "—"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, [
                      ((r.courseexemptions || []).length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Miễn " + _toDisplayString(r.courseexemptions.length) + " môn", 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_17, _toDisplayString((r.courseexemptions || []).map((i) => i.name).join('; ')), 1)
                    ]),
                    _createElementVNode("td", _hoisted_18, [
                      (_ctx.isFullExempt(r))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Miễn học hoàn toàn"))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.nextLevelText(r) || '—'), 1)
                          ], 64))
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
  ]))
}